import React from "react"
import { Accordion, Card, Container } from "react-bootstrap"
import { graphql, useStaticQuery } from "gatsby"
import { IoMdArrowDropdown } from "react-icons/io"

const FAQ = () => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        fqa_heading
        faq {
          id
          question
          answer
        }
      }
    }
  `)

  const {
    strapiHomePage: { fqa_heading, faq },
  } = data

  return (
    <Container className="faq">
      <h1 className="text-start text-lg-center text-md-center my-4">
        {fqa_heading}
      </h1>
      <Accordion defaultActiveKey="0">
        {faq.map((item, index) => {
          return (
            <Card key={index}>
              <Accordion.Toggle
                as={Card.Header}
                eventKey={item.id}
                className="d-flex align-items-center justify-content-between"
              >
                <h6>{item.question}</h6>
                <IoMdArrowDropdown />
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={index + 1}>
                <Card.Body>
                  <p>{item.answer}</p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          )
        })}
      </Accordion>
    </Container>
  )
}

export default FAQ
